import { SIGNIN, SIGNOUT } from '../types/auth';
import authService from '../../services/authService';
import { notification } from 'antd';

export function signIn(user) {
  return async (dispatch) => {
    try {
      const auth = await authService.signIn({
        username: user.username,
        password: user.password,
      });

      dispatch({
        type: SIGNIN,
        payload: auth,
      });

      return Promise.resolve({ message: auth.message });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function signOut() {
  return async (dispatch) => {
    try {
      dispatch({
        type: SIGNOUT,
      });

      notification.open({
        type: 'success',
        message: 'Sesión cerrada con éxito',
        placement: 'bottomRight',
      });
      return Promise.resolve();
    } catch (error) {
      return Promise.reject();
    }
  };
}
